import axios from "axios";
import { API_BASE_URL } from "../../lib/constants";
import { toast } from "../../hooks/use-toast";
import Cookie, { JWT_COOKIE_NAME } from "../../lib/cookie";

// Base API URL (replace with your actual backend URL)
console.log("Base Url is : "+ API_BASE_URL + "/api/");
// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL + "/api/",
  timeout: 30000, // Timeout after 30s
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach Token If Available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve token from local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
api.interceptors.response.use(
  (response) => response,
  (error) => {
    let title = "Error";
    let message = "An unexpected error occurred.";

    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 400:
          title = "Bad Request";
          message =
            data?.message || "Invalid input. Please check your request.";
          break;
        case 401:
          title = "Unauthorized";
          message = "Session expired. Please log in again.";
          localStorage.removeItem("user");
          Cookie.remove(JWT_COOKIE_NAME);
          break;
        case 403:
          title = "Access Denied";
          message = "Please log in.";
          localStorage.removeItem("user");
          Cookie.remove(JWT_COOKIE_NAME);
          break;
        case 404:
          title = "Not Found";
          message = "Requested resource could not be found.";
          break;
        case 500:
          title = "Server Error";
          message = "Internal server error. Try again later.";
          break;
        default:
          title = `Error ${status}`;
          message = data?.message || "Something went wrong.";
      }
    } else if (error.request) {
      title = "Network Error";
      message = "No response from server. Please check your connection.";
    } else {
      title = "Unexpected Error";
      message = error.message || "An error occurred.";
    }

    toast({
      title,
      description: message,
    });

    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;
